var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneAll24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.205 5.29671L12.6241 15.8758L8.44447 11.7055L7.03436 13.1154L12.6239 18.7058L24.6249 6.70683L23.205 5.29671ZM18.9649 6.70636L17.555 5.29625L11.2145 11.6357L12.6244 13.0458L18.9649 6.70636ZM6.9639 18.7054L1.37436 13.1149L2.79447 11.705L8.37402 17.2955L6.9639 18.7054Z",
    fill: "#003366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneAll24Px);
export default __webpack_public_path__ + "static/media/done_all_24px.960ba44c03238bd58bfb0b0dbada3124.svg";
export { ForwardRef as ReactComponent };